import { render, staticRenderFns } from "./modifyMenu.vue?vue&type=template&id=b868b74a&scoped=true"
import script from "./modifyMenu.vue?vue&type=script&lang=js"
export * from "./modifyMenu.vue?vue&type=script&lang=js"
import style0 from "./modifyMenu.vue?vue&type=style&index=0&id=b868b74a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b868b74a",
  null
  
)

export default component.exports